import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import NameModal from '../../components/modals/NameModal';
import LinktreeButton from '../../components/oracle/LinktreeButton';

// Iconos e imágenes
import { FaInstagram, FaYoutube } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6"; 
import perfilImg from '../../assets/images/perfil.png';
import merkabaImg from '../../assets/images/merkaba/Merkaba.png';
import { sendCodedLog } from '../../services/logService';
import Common from '../../common/Common';
import ContactSection from '../../components/common/ContactSection';
import { getRandomCardImage } from '../../assets/oracle/deck';

// --- CONFIGURACIÓN DEL MENÚ ---
const menuItems = [
  // {
  //   title: "Lectura de tu Estado Actual",
  //   subtitle: "Obten una lectura para el tema que te inquieta hoy día",
  //   cardCount: 3, 
  //   path: "/oraculo/lectura/estado",
  //   featured: true,
  // },
  // {
  //   title: "Lectura de Triple Energía",
  //   subtitle: "Obten una lectura para el tema que te inquieta hoy día",
  //   cardCount: 3, 
  //   path: "/oraculo/lectura/triple",
  //   featured: true,
  // },
  {
    title: "Lectura Estrella",
    subtitle: "Obten una lectura completa para un tema específico",
    cardCount: 5,
    layout: 'cross', // <--- Disposición en estrella / X de 5 cartas
    path: "/oraculo/lectura/estrella",
    featured: true,
  },
  {
    title: "Tu Carta del Día",
    subtitle: "Recibe una guía para tu camino",
    image: getRandomCardImage(),
    path: "/oraculo/lectura/hoy",
    featured: true,
  },
  {
    title: "Ver el Oráculo Completo",
    subtitle: "Navega a través de las Leyes Universales",
    cardCount: 5,
    path: "/oraculo",
    featured: true,
  },
  // {
  //   title: "Lectura Manual",
  //   subtitle: "Elige tus cartas y descubre su mensaje",
  //   cardCount: 2,
  //   path: "/oraculo/lectura/manual",
  //   featured: false,
  // },
];

const OracleMenuPageEs = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [showNameModal, setShowNameModal] = useState(false);
  const [guestName, setGuestName] = useState('');
  const [merkabaOpacity, setMerkabaOpacity] = useState(0);
  const [merkabaRotation, setMerkabaRotation] = useState(0);
  const [titleGlowIntensity, setTitleGlowIntensity] = useState(0.2);

  const displayName = user?.name || guestName;

  useEffect(() => {
    const savedGuestName = localStorage.getItem('track_user_name');
    if (savedGuestName) {
      setGuestName(savedGuestName);
    }
    const nameModalDismissed = sessionStorage.getItem('nameModalDismissed');
    if (!user && !nameModalDismissed && !savedGuestName) {
      const timer = setTimeout(() => setShowNameModal(false), 7000);
      return () => clearTimeout(timer);
    }
  }, [user]);

  useEffect(() => {
    let currentRotation = 0;
    const animateMerkaba = () => {
      currentRotation = (currentRotation + 30) % 360;
      setMerkabaRotation(currentRotation); setMerkabaOpacity(0.5);
      const fadeOutTimer = setTimeout(() => setMerkabaOpacity(0), 2000);
      const loopTimer = setTimeout(animateMerkaba, 3500);
      return () => { clearTimeout(fadeOutTimer); clearTimeout(loopTimer); };
    };
    const initialDelay = setTimeout(animateMerkaba, 500);
    return () => clearTimeout(initialDelay);
  }, []);

  useEffect(() => {
    const animateGlow = () => setTitleGlowIntensity(prev => (prev === 0.2 ? 0.4 : 0.2));
    const glowInterval = setInterval(animateGlow, 3000);
    return () => clearInterval(glowInterval);
  }, []);

  const handleNameSubmit = (name) => {
    localStorage.setItem('track_user_name', name);
    setGuestName(name);
    setShowNameModal(false);
    sendCodedLog({ message: 'Invitado añadió su nombre', event: 'guest_name_set_es', ...Common.getCommonLogData(location) });
  };

  const handleModalClose = () => {
    sessionStorage.setItem('nameModalDismissed', 'true');
    setShowNameModal(false);
    sendCodedLog({ message: 'Invitado cerró el modal de nombre', event: 'guest_modal_name_dismiss_es', ...Common.getCommonLogData(location) });
  };

  const handleLinktreeButtonClick = (title, path) => {
    sendCodedLog({ message: `Click en botón "${title}" (${path})`, event: 'home_oraculo_portal_button_click_es', ...Common.getCommonLogData(location) });
  };
  
  const handleProfileImageClick = () => sendCodedLog({ message: 'Click en imagen de perfil', event: 'home_profile_image_click_es', ...Common.getCommonLogData(location) });
  
  const handleSocialMediaClick = (platform, url) => {
    sendCodedLog({ message: `Click en red social (Home): ${platform}`, event: `home_social_media_click_${platform.toLowerCase()}_es`, ...Common.getCommonLogData(location) });
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  
  const handleInstagramClick = (e) => { e.preventDefault(); handleSocialMediaClick('Instagram', 'https://instagram.com/quantum.gus'); };
  const handleTiktokClick = (e) => { e.preventDefault(); handleSocialMediaClick('TikTok', 'https://www.tiktok.com/@quantum.gus'); };
  const handleYoutubeClick = (e) => { e.preventDefault(); handleSocialMediaClick('YouTube', 'https://www.youtube.com/@imanifesti'); };

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-neutral-900 to-black"></div>

      <main className="relative z-10 flex-grow container mx-auto px-4 py-12 flex flex-col items-center">

        <div className="relative flex items-center justify-between mb-8 w-full max-w-2xl mx-auto">
          <h1 className="relative z-10 text-3xl sm:text-6xl font-bold leading-none text-left mt-7 mb-7" style={{ fontFamily: '"Cinzel Decorative", serif', backgroundImage: 'linear-gradient(to bottom, #FFEC8B, #FFD700, #DAA520, #B8860B)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textShadow: `0 0 8px rgba(255, 215, 0, ${titleGlowIntensity}), 0 0 12px rgba(255, 215, 0, ${titleGlowIntensity / 2})`, transition: 'text-shadow 1.5s ease-in-out' }}>
            Portal
          </h1>
          <img src={merkabaImg} alt="Golden Merkaba" className="absolute z-0 w-8 h-8 sm:w-12 sm:h-12 object-contain rounded-full transition-all duration-1000 ease-in-out" style={{ opacity: merkabaOpacity, top: '50%', left: '50%', transform: `translate(-50%, -50%) rotate(${merkabaRotation}deg)` }} />
          <h1 className="relative z-10 text-3xl sm:text-6xl font-bold leading-none text-right mt-7 mb-7" style={{ fontFamily: '"Cinzel Decorative", serif', backgroundImage: 'linear-gradient(to bottom, #FFEC8B, #FFD700, #DAA520, #B8860B)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textShadow: `0 0 8px rgba(255, 215, 0, ${titleGlowIntensity}), 0 0 12px rgba(255, 215, 0, ${titleGlowIntensity / 2})`, transition: 'text-shadow 1.5s ease-in-out' }}>
            Oracle
          </h1>
        </div>

        <div className="text-center mb-10">
            <div className="relative flex items-baseline justify-center gap-2">
                <h2 className="relative z-10 text-2xl sm:text-2xl font-bold leading-none" style={{ fontFamily: '"Cinzel Decorative", serif', backgroundImage: 'linear-gradient(to bottom, #FFEC8B, #c4c1b3ff, #e4d4adff, #e7d9b6ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                    Hola,
                </h2>
            </div>
            <h1 className="relative z-10 text-3xl sm:text-4xl font-bold leading-none mt-2" style={{ fontFamily: '"Cinzel Decorative", serif', backgroundImage: 'linear-gradient(to bottom, #FFEC8B, #c4c1b3ff, #e4d4adff, #e7d9b6ff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', textShadow: `0 0 8px rgba(255, 215, 0, ${titleGlowIntensity}), 0 0 12px rgba(255, 215, 0, ${titleGlowIntensity / 2})`, transition: 'text-shadow 1.5s ease-in-out' }}>
                {displayName || 'Viajero'}
            </h1>
            <p className="text-sm sm:text-base text-gray-400 mt-3 max-w-sm mx-auto">
                {user
                    ? "Continúa tu viaje de transformación."
                    : guestName
                        ? `¡Bienvenido, ${guestName}! Obtén tu guia a través del Oráculo Metafísico.`
                        : "Obtén tu guia a través del Oráculo Metafísico."
                }
            </p>
        </div>
        
        <div className="w-full flex flex-col items-center">
          {menuItems.map((item, index) => (
            <LinktreeButton key={item.path + index} item={item} index={index} onButtonClick={handleLinktreeButtonClick} />
          ))}
        </div>

        {!displayName && (
            <div className="flex flex-col items-center mt-12 mb-8">
                <img
                    src={perfilImg}
                    alt="Foto de perfil" 
                    className="w-24 h-24 sm:w-28 sm:h-28 rounded-full mb-2 object-cover border-4 border-gray-700 shadow-lg cursor-pointer"
                    onClick={handleProfileImageClick}
                />
                <h2 className="text-xl sm:text-2xl font-bold mb-0.5 text-white">
                    Gustavo • Aguiar
                </h2>
                <p className="text-sm sm:text-base text-gray-400 text-center max-w-sm mb-8">
                    Coach Metafísico <br/> Desbloquea tu estado mental y entra en estados del ser elevados.
                </p>
            </div>
        )}

        <ContactSection></ContactSection>

        <div className="flex justify-center gap-6 text-2xl text-gray-300 mt-8">
          <a onClick={handleInstagramClick} aria-label="Instagram" className="hover:text-white cursor-pointer"><FaInstagram /></a>
          <a onClick={handleTiktokClick} aria-label="TikTok" className="hover:text-white cursor-pointer"><FaTiktok /></a>
          <a onClick={handleYoutubeClick} aria-label="YouTube" className="hover:text-white cursor-pointer"><FaYoutube /></a>
        </div>
      </main>

      <footer className="relative z-10 text-center py-6 text-xs text-gray-600">
        <p>© {new Date().getFullYear()} Gustaf | En la misión de elevar y transformar.</p>
      </footer>

      {showNameModal && <NameModal onClose={handleModalClose} onSubmitName={handleNameSubmit} />}
    </div>
  );
};

export default OracleMenuPageEs;